import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { eps } from './url.service'
import { catchError, Observable, of } from 'rxjs'
import { Holiday } from '../components/leaves/holidays/holidays.component'

@Injectable({
  providedIn: 'root'
})
export class AttendancePolicyService {
  private http = inject(HttpClient) // Use inject() instead of constructor injection
  private api = eps.attendance

  list(businessId?: string, search?: string, page?: number, limit?: number): Observable<any> {
    let params = new HttpParams()
    if (businessId) {
      params = params.set('businessId', businessId)
    }
    if (search) {
      params = params.set('title', search)
    }
    if (page) {
      params = params.set('page', page)
    }
    if (limit) {
      params = params.set('limit', limit)
    }
    return this.http.get<any>(this.api.policiesApi, { params })
  }

  create(holiday: Holiday): Observable<Holiday> {
    return this.http.post<Holiday>(this.api.policiesApi, holiday)
  }

  update(id: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.api.policiesApi}/${id}`, { ...data })
  }

  delete(id: string): Observable<Holiday> {
    return this.http.delete<Holiday>(`${this.api.policiesApi}/${id}`)
  }

  assignedPolicyList(businessId: string, page: number, limit: number): Observable<any> {
    let params = new HttpParams()
    params = params.set('businessId', businessId)
    params = params.set('page', page)
    params = params.set('limit', limit)
    return this.http.get<any>(this.api.assignedPolicyApi, { params })
  }

  assignedPolicyByUserId(userId: string): Observable<any> {
    const url = `${this.api.assignedPolicyApi}/${userId}`
    return this.http.get<any>(url).pipe(catchError(() => of([])))
  }

  assignPolicy(data: any): Observable<any> {
    return this.http.post<any>(this.api.assignedPolicyApi, data)
  }

  setDefaultPolicy(policyId: string): Observable<{ message: string; data: any }> {
    return this.http.patch<{ message: string; data: any }>(
      `${this.api.policiesApi}/${policyId}/default`,
      {}
    )
  }

  getSummary(filter: string) {
    return this.http.get<any>(`${this.api.policiesApi}/summary?${filter}`);
  }

  // This code is added by shivam
  // attendance.service.ts

  updateAssignmentValidity(data: { id: string; validUpto: string }) {
    return this.http.put(
      `${eps.attendance.assignedPolicyApi}/${data.id}`,
      { validUpto: data.validUpto }
    );
  }
  deleteAssignment(id: string) {
    return this.http.delete(
      `${eps.attendance.assignedPolicyApi}/${id}`
    );
  }
}
